export default "__VITE_ASSET__13cb511d__"